<template>
  <div v-if="activeTravel && !isOnCurrentPage" class="atb-bar">
      <div class="atb-icon-wrap">
        <v-icon size="20" color="white">mdi-bullhorn-variant</v-icon>
      </div>
      <div class="atb-body">
        <div class="atb-title">{{ title }}</div>
        <div class="atb-text">{{ text }}</div>
      </div>
      <v-btn small dark depressed class="atb-btn" @click="navigate">
        {{ btnLabel }}
      </v-btn>
    </div>
</template>

<script>
import { getMyTravelsApi } from "@/services/api/travel";
import { riderApi } from "@/services/api/api";

const USER_ACTIVE = ["pending", "seeking_rider", "rider_accepted", "in_progress"];
const RIDER_ACTIVE = ["rider_accepted", "in_progress"];

const USER_HIDE_ROUTES = ["call_rider", "travel-qr-payment"];
const RIDER_HIDE_ROUTES = ["rider_travel_detail"];

export default {
  name: "ActiveTravelBanner",

  props: {
    role: { type: String, default: "user" },
  },

  data() {
    return { activeTravel: null };
  },

  computed: {
    isPending() {
      return this.activeTravel?.status === "pending";
    },
    title() {
      return this.isPending ? "รอชำระเงิน" : "แจ้งเตือนการติดตาม";
    },
    text() {
      return this.isPending
        ? "มีรายการที่รอชำระเงินค่าบริการ กรุณาชำระเพื่อเรียกไรเดอร์"
        : "กรุณาเปิดหน้าจอติดตามผล เพื่อสะดวกในการใช้บริการแบบออนไลน์";
    },
    btnLabel() {
      return this.isPending ? "ชำระเงิน" : "ติดตาม";
    },
    isOnCurrentPage() {
      const hideRoutes = this.role === "rider" ? RIDER_HIDE_ROUTES : USER_HIDE_ROUTES;
      return hideRoutes.includes(this.$route?.name);
    },
  },

  watch: {
    $route() {
      this.fetchActiveTravel();
    },
  },

  mounted() {
    this.fetchActiveTravel();
    this.$root.$on("travel:refresh-banner", this.fetchActiveTravel);
  },

  beforeDestroy() {
    this.$root.$off("travel:refresh-banner", this.fetchActiveTravel);
  },

  methods: {
    async fetchActiveTravel() {
      try {
        if (this.role === "user") {
          const token = localStorage.getItem("user_token") || localStorage.getItem("token");
          if (!token) { this.activeTravel = null; return; }
          const res = await getMyTravelsApi();
          const travels = Array.isArray(res?.data) ? res.data : [];
          this.activeTravel = travels.find(t => USER_ACTIVE.includes(t.status)) || null;
        } else {
          const token = localStorage.getItem("rider_token");
          if (!token) { this.activeTravel = null; return; }
          const res = await riderApi.get("/api/v1/auth/rider/travels");
          const travels = Array.isArray(res?.data?.data) ? res.data.data : [];
          this.activeTravel = travels.find(t => RIDER_ACTIVE.includes(t.status)) || null;
        }
      } catch {
        this.activeTravel = null;
      }
    },

    navigate() {
      const t = this.activeTravel;
      if (!t) return;
      if (this.role === "rider") {
        this.$router.push({ name: "rider_travel_detail", params: { id: t.id } }).catch(() => {});
      } else if (t.status === "pending") {
        this.$router.push({ name: "travel-qr-payment", params: { travelId: t.id, total: t.price } }).catch(() => {});
      } else {
        this.$router.push({ name: "call_rider", query: { resumeTravel: t.id } }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.atb-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #ea580c 0%, #F4811F 60%, #F59E0B 100%);
  padding: 12px 16px;
  box-shadow: 0 4px 16px rgba(234, 88, 12, 0.40);
  animation: atb-pulse 2.2s ease-in-out infinite;
  position: sticky;
  top: 0;
  z-index: 10;
  overflow: hidden;
}

.atb-icon-wrap {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.atb-body {
  flex: 1;
  min-width: 0;
}

.atb-title {
  font-weight: 700;
  font-size: 13px;
  color: #fff;
  line-height: 1.3;
}

.atb-text {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.atb-btn {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.25) !important;
  border: 1.5px solid rgba(255, 255, 255, 0.7) !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
}

@keyframes atb-pulse {
  0%, 100% { box-shadow: 0 4px 16px rgba(234, 88, 12, 0.40); }
  50% { box-shadow: 0 4px 28px rgba(234, 88, 12, 0.70); }
}

</style>
